/**
 * @fileoverview Map browser routes to shared employee-workspace identities. `AppAccessContext.js` owns accepted availability and `App.js`/sidebar consume these mappings. Route identity supports consistent navigation and guards without becoming a backend permission policy.
 */

export const WORKSPACE_PATHS = [
    ['matters', '/matters'],
    ['intake', '/intake'],
    ['inbox', '/inbox'],
    ['calendar', '/calendar'],
    ['documents', '/documents'],
    ['assistant', '/document_chat'],
    ['trello-tasks', '/trello_tasks'],
    ['automations', '/automations'],
    ['utilities', '/utilities'],
    ['sync', '/sync'],
    ['logs', '/logs'],
    ['drafting-runs', '/drafting-runs'],
]

 
export function sectionForLocation({ pathname = '/', search = '' } = {}) {
    const path = pathname.replace(/\/+$/, '') || '/'
    if (path === '/' || path === '/new-matters-table' || path.startsWith('/case_details/')) return 'matters'
    if (path.startsWith('/payment-instructions/')) return 'inbox'
    if (path === '/admin' || path.startsWith('/local/')) return 'admin'
    if (path === '/settings') {
        const tab = new URLSearchParams(search).get('tab')
        if (tab === 'client-portal') return 'admin'
        return ['intake', 'notification-rules', 'case-attribute-types'].includes(tab)
            ? `settings-${tab}` : null
    }
    return WORKSPACE_PATHS.find(([, prefix]) => path === prefix || path.startsWith(`${prefix}/`))?.[0] || null
}
